export default function DOM_Navigating() {
  return (
    <div>
      <h1>DOM_Navigating</h1>
      <p>This is the DOM_Navigating component.</p>
    </div>
  );
}